/**
 * Centralized time-related constants used across the application
 * This file consolidates all time constants to prevent duplication
 */

// ===== Core Time Constants =====
export const MINUTES_PER_HOUR = 60;
export const HOURS_PER_DAY = 24;
export const MINUTES_PER_DAY = HOURS_PER_DAY * MINUTES_PER_HOUR;

// ===== Calendar and Scheduling Constants =====
export const INTERVAL_MINUTES = 15;
export const INTERVALS_PER_HOUR = MINUTES_PER_HOUR / INTERVAL_MINUTES;

// ===== UI Layout Constants =====
export const ROW_HEIGHT_PX = 64;
export const PIXELS_PER_MINUTE = 5 / INTERVAL_MINUTES;

// ===== Time Range Constants =====
export const DEFAULT_DISPLAY_START_HOUR = 0;
export const DEFAULT_DISPLAY_END_HOUR = 24;
export const DEFAULT_BUSINESS_BUFFER_HOURS = 1;

// ===== Attendance Constants =====
export const EARLY_ARRIVAL_THRESHOLD_MINUTES = 30;
export const EARLY_DEPARTURE_THRESHOLD_MINUTES = 15;
export const PUNCTUALITY_GRACE_PERIOD_MINUTES = 5;

// ===== Time Format Patterns =====
export const TIME_FORMAT_24H = 'HH:mm';
export const TIME_FORMAT_12H = 'h:mm a';
export const DATETIME_FORMAT_DISPLAY = 'MMM d, yyyy h:mm a';

// ===== Validation Constants =====
export const MAX_SHIFT_DURATION_HOURS = 12;
export const MIN_BREAK_DURATION_MINUTES = 5;
export const MAX_OVERTIME_EXTENSION_HOURS = 3;

// ===== Time Calculation Helpers =====
export const MILLISECONDS_PER_MINUTE = 60 * 1000;
export const MILLISECONDS_PER_HOUR = MINUTES_PER_HOUR * MILLISECONDS_PER_MINUTE;

/**
 * Common time intervals in minutes for dropdowns and calculations
 */
export const COMMON_TIME_INTERVALS = {
  FIVE_MINUTES: 5,
  FIFTEEN_MINUTES: 15,
  THIRTY_MINUTES: 30,
  ONE_HOUR: 60,
  TWO_HOURS: 120,
  FOUR_HOURS: 240,
} as const;

/**
 * Default time ranges for different business types
 */
export const DEFAULT_TIME_RANGES = {
  RESTAURANT: {
    START_HOUR: 8,
    END_HOUR: 23,
  },
  RETAIL: {
    START_HOUR: 9,
    END_HOUR: 21,
  },
  OFFICE: {
    START_HOUR: 7,
    END_HOUR: 19,
  },
  HEALTHCARE: {
    START_HOUR: 6,
    END_HOUR: 24, // 24-hour operation
  },
} as const;